import { render } from "./Rubble.vue?vue&type=template&id=5757d4f0"
import script from "./Rubble.vue?vue&type=script&lang=js"
export * from "./Rubble.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Rubble.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5757d4f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5757d4f0', __exports__)) {
    api.reload('5757d4f0', __exports__)
  }
  
  module.hot.accept("./Rubble.vue?vue&type=template&id=5757d4f0", () => {
    api.rerender('5757d4f0', render)
  })

}


export default __exports__